import { Panel } from "@/design-system/Panel";
import { useUnattributedDeposits } from "@/shared/clients/deposits";
import { money } from "@/shared/money/money";

function usdt(value: string): string {
  return `${money(value)} USDT`;
}

/** Fee payments from a Bybit UID no client has connected; nothing when none. */
export function UnattributedDeposits(): React.JSX.Element | null {
  const query = useUnattributedDeposits();
  if (query.data === undefined || query.data.length === 0) return null;
  return (
    <Panel title="Нераспознанные оплаты комиссии" testId="unattributed-deposits">
      <p className="text-body-main text-text-secondary">
        Переводы с UID, который не подключён ни к одному клиенту. Засчитаются сами, когда клиент подключит этот счёт Bybit.
      </p>
      <ul className="mt-2 flex flex-col gap-1 text-body-main">
        {query.data.map((item) => (
          <li key={`${item.from_member_id}-${item.at}`} className="flex flex-wrap justify-between gap-x-4 tabular-nums">
            <span className="font-mono text-data-mono">UID {item.from_member_id}</span>
            <span>{new Date(item.at).toLocaleString("ru-RU")}</span>
            <span className="text-text-primary">+{usdt(item.amount)}</span>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
